import React from 'react';
import PropTypes from 'prop-types';

// Types
import { listTypes } from '../../../conf/enums';

// Components
import { Dialog } from '../../../../components/Dialog';
import { DialogHeader } from '../../../../components/DialogHeader';

// Child Components
import { ListItemEditableForm } from './components/listItemEditableForm';
import { ListItemReadOnlyForm } from './components/listItemReadOnlyForm';

const editableListTypes = [listTypes.AD_HOC];

export const ListItem = ({ listId, isNew, data, closeDialog, isExistingDoc, saveDisabled, onApply, type }) => {
    const CloseDialog = () => {
        return typeof closeDialog === 'function' ? closeDialog() : null;
    };
    const isEditable = React.useMemo(() => editableListTypes.includes(type), [type]);

    return (
        <Dialog close={CloseDialog} size="lg" visible id="list-manager-list-item">
            <DialogHeader close={CloseDialog}>List Item Editor</DialogHeader>
            {isEditable ? (
                <ListItemEditableForm
                    data={data}
                    closeDialog={CloseDialog}
                    isNew={isNew}
                    onApply={onApply}
                    isExistingDoc={isExistingDoc}
                    saveDisabled={saveDisabled}
                    listId={listId}
                    type={type}
                />
            ) : (
                <ListItemReadOnlyForm data={data} closeDialog={CloseDialog} />
            )}
        </Dialog>
    );
};

export default ListItem;

ListItem.propTypes = {
    data: PropTypes.object,
    formModel: PropTypes.arrayOf(PropTypes.object),
    isNew: PropTypes.bool,
    closeDialog: PropTypes.func,
    isExistingDoc: PropTypes.func,
    onApply: PropTypes.func,
    listId: PropTypes.string,
    type: PropTypes.string,
    saveDisabled: PropTypes.bool
};
